/**
 * Classe com os eventos de checkbox
 * @author: Adalto Junior adaltojunior@sagarantech.com
 * DATE: 15/08/2013
 *
 */

Greenmile.ServiceTimeUpdates = Greenmile.ServiceTimeUpdates || {};

Greenmile.ServiceTimeUpdates.GridEventsListener = function () {

    var reject = (input) => {

        var error  = null,
            router = null,
            row    = null,
            id     = null;

        try {

            if (input !== null) {

                router = App.Objects.ServiceTimeUpdates;

                id = input.getAttribute("identity");
                row = input.getAttribute("row");

                router.rejectAndRemoveRow(id, [row]);

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this, "Error on reject", e);
            error.console();

        }
    };

    var accept = (input) => {

        var error  = null,
            row    = null,
            id     = null;

        try {

            if (input !== null) {

                id = input.getAttribute("identity");
                row = input.getAttribute("row");

                App.Objects.ServiceTimeUpdates.acceptAndRemoveRow(id, [row]);

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this, "Error on accept", e);
            error.console();

        }
    };

    var check = (input) => {

        var error = null,
            row   = null,
            grid  = null;

        try {

            if (input !== null) {

                grid = App.Forms.ServiceTimeUpdates.table;
                row = input.getAttribute("row");

                if (input.checked) {
                    grid.setSelectedRow(row);
                } else {
                    Monet.Session.ServiceTimeUpdates.allChecked = null;
                    grid.removeSelectedRow(row);
                }

                grid.checkAllOnListenner();

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this, "Error on check", e);
            error.console();

        }

    };

    var checkAll = (input) => {

        var error     = null,
            grid      = null,
            data      = null,
            isChecked = false;

        try {

            grid = App.Forms.ServiceTimeUpdates.table;
            data = App.Forms.ServiceTimeUpdates.dataProvider.data;

            isChecked = input.checked;

            Monet.Session.ServiceTimeUpdates.allChecked = isChecked;

            for (var i = 0; i < data.length; i++) {

                if (isChecked) {

                    grid.setSelectedRow(i);

                } else {

                    grid.removeSelectedRow(i);

                }
            }

            grid.invalidate();

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on register accept item event listener.", e);
            error.console();

        }

    };

    var checkAllItems = (input) => {
        return function () {
            checkAll(input);
        };
    };

    var registerCheckAllCheckBoxColumn = () => {

        var error    = null,
            selector = "#ServiceTimeUpdates input[type='checkbox'].checkAll",
            input    = null;

        try {

            input = document.querySelector(selector);

            if (input !== null) {
                input.removeEventListener("click", checkAllItems(input));
                input.addEventListener("click", checkAllItems(input));
            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on register check all ceckbox column", e);
            error.console();

        }

    };

    this.checkOrUncheckCheckboxColumnHeader = (allChecked) => {

        var error    = null,
            selector = "#ServiceTimeUpdates input[type='checkbox'].checkAll",
            input    = null;

        try {

            input = document.querySelector(selector);


            if (input !== null) {

                if (allChecked) {
                    input.checked = "checked='checked'";
                } else {
                    input.checked = false;
                }

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "error on check or unchek checkbox column header", e);
            error.console();

        }

    };

    this.acceptItem = (input) => {
        accept(input);
    };

    this.rejectItem = (input) => {
        reject(input);
    };

    this.checkItem = (input) => {
        check(input);
    };

    this.headerElementListener = () => {

        registerCheckAllCheckBoxColumn();

    };

};